import { useEffect } from "react";

// The lock is shared by all consumers so nested overlays do not fight over
// the body styles or restore them while another overlay is still open.
let lockCount = 0;
let priorOverflow = null;
let priorPaddingRight = null;

function scrollbarWidth() {
  if (typeof window === "undefined" || typeof document === "undefined") return 0;

  const viewportWidth = window.innerWidth;
  const documentWidth = document.documentElement?.clientWidth;
  if (!Number.isFinite(viewportWidth) || !Number.isFinite(documentWidth) || documentWidth <= 0) {
    return 0;
  }
  return Math.max(0, viewportWidth - documentWidth);
}

function acquire() {
  if (typeof document === "undefined" || !document.body) return;

  if (lockCount === 0) {
    priorOverflow = document.body.style.overflow;
    priorPaddingRight = document.body.style.paddingRight;
    const gap = scrollbarWidth();

    document.body.style.overflow = "hidden";
    if (gap > 0) {
      const currentPadding = parseFloat(getComputedStyle(document.body).paddingRight) || 0;
      document.body.style.paddingRight = `${currentPadding + gap}px`;
    }
  }
  lockCount += 1;
}

function restoreInlineStyle(property, value) {
  if (value === "") {
    document.body.style.removeProperty(property);
  } else {
    document.body.style[property] = value;
  }
}

function release() {
  if (lockCount === 0) return;
  lockCount -= 1;
  if (lockCount !== 0 || typeof document === "undefined" || !document.body) return;

  restoreInlineStyle("overflow", priorOverflow);
  restoreInlineStyle("padding-right", priorPaddingRight);
  priorOverflow = null;
  priorPaddingRight = null;
}

/** Ref-counted body scroll lock. Never uses position:fixed (loses iOS scroll position). */
export function useBodyScrollLock(locked) {
  useEffect(() => {
    if (!locked) return undefined;
    acquire();
    return () => release();
  }, [locked]);
}
